import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const companycam = defineConnector({
  identifier: "companycam",
  name: "CompanyCam",
  tagLine: "Photo documentation for contractors",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.companycam\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Find your CompanyCam API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Open the [CompanyCam getting started docs](https://developer.companycam.com/docs/get-started) and create or copy an API token from your CompanyCam developer settings. Use a token from the account that owns the projects and photos you need.",
        },
      ],
    },
    {
      title: "Enter your API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Enter the API credentials from your CompanyCam account settings.",
        },
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
          helperText: "The Access Token for your CompanyCam company",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.companycam.com/v2/company",
  },
});
